import { autobind } from '../../../core/lib';
import React from 'react';
import PropTypes, { string } from 'prop-types';
import cls from '../utils/classnames';
import './_styles.scss';
import { KEYBOARD, KEYBOARD_HEADER, KEYBOARD_TABS } from '../utils/classes';
import { ColoredButton } from '../ColoredButton';
import { IFormChildContext } from '../Form';

import { Tab } from './Tab';
import { Keyset } from './Keyset';

import { Keys } from './types';
import {
    TabType,
    KeyName,
    SYMBOL_KEYS,
    SHIFT,
    CONTEXT_KEYS,
    UPPER_CASE_KEYS,
    LOWER_CASE_KEYS,
    FIXED_KEYS,
    CONTEXT_KEYS_STRING,
    DIGITS_KEYS
} from './constants';
import Device from 'src/devices/device';
import DeviceStorage from 'src/components/DeviceStorage/DeviceStorage';
import Metadata from 'src/requests/apa/Metadata';
import Translator from "../../../../requests/apa/Translator";
import store from 'src/store';
import { MODAL_PIN } from 'src/actions/modal';
import Utils from '../../../../utils/Utils';
export interface IKeyboardProps {
    /**
     * Id to add to element
     */
    id?: string;
    /**
     * className to add to element
     */
    className?: string;
    /**
     * to enable only digits keys
     */
    onlyDigits?: boolean;
    /**
     * onlyDigits?: boolean;
     */
    withoutEmails?:boolean;
    /* is used only in net register
     */
    isRegisterNet?: boolean;
    /**
     * to empty all fields
     */
    emptyAllField?: boolean;
    /**
      * callback to execute when press empty tab
      */
    emptyCallback?: ()=>{}
    /**
     * Array to add keyboard empty function
     */
    emptyFunctionArr?: []
    /**
     * fucus in kerBoard
     */
    onFocus(): void;
    /**
     * filter characteres in context to avoid mistakes when input<Form component has filtered characters enabled
     */
    filteredFuncion?(value: string, type : string): string;
    /**
     * Callback to executed when delete shortcut is fired to control the delete behavior with this function
     */
    onControlDeleteCallback?: (activeField: string, values: { [key: string]: string }, deleteCallback: ()=> void )=>{}

    /* If the component is from Search*/
    fromSearch?:boolean;
    sourceSearcher?:boolean;
}

export interface IKeyboardState {
    /**
     * string to know what tab is active
     */
    activeTab: TabType;
    /**
     * string to know what keys are active
     */
    activeKeyset: KeyName;
}

export class Keyboard extends React.PureComponent<IKeyboardProps, IKeyboardState> {
    public static contextTypes = {
        $form: PropTypes.object
    };

    public context: IFormChildContext;

    private readonly region: string;
    private keys: any;
    private elementSearch: any;
    private isPathSearchWithStyles: boolean;

    constructor(props: IKeyboardProps, context: IFormChildContext) {
        super(props, context);
        this.state = {
            activeTab: !props.isRegisterNet ? TabType.LETTERS : TabType.SYMBOLS,
            activeKeyset: !props.isRegisterNet ? KeyName.LOWER_CASE_LETTERS : KeyName.SYMBOLS
        };
        this.region = DeviceStorage.getItem("region") || 'default';
        this.keys = Device.getDevice() && Device.getDevice().getKeys() || null;
        this.elementSearch = null;
        this.isPathSearchWithStyles = false;
    }

    public componentWillMount(): void {
        // eslint-disable-next-line react/destructuring-assignment
        if (!(this.context && this.context.$form)) {
            throw new Error('Keyboard must be used within a Form');
        }
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        const { $form } = this.context;
        const {id} = this.props;
        const { activeField = '', values = {} } = $form || {};
        switch(currentKey){
            case "BLUE":
                return this.handleEmptyTabClick();
            case "GREEN":
                return this.handleDeleteTabClick();
            case "ZERO":
                return this.handleKeyPress("0", id);
            case "ONE":
                return this.handleKeyPress("1", id);
            case "TWO":
                return this.handleKeyPress("2", id);
            case "THREE":
                return this.handleKeyPress("3", id);
            case "FOUR":
                return this.handleKeyPress("4", id);
            case "FIVE":
                return this.handleKeyPress("5", id);
            case "SIX":
                return this.handleKeyPress("6", id);
            case "SEVEN":
                return this.handleKeyPress("7", id);
            case "EIGHT":
                return this.handleKeyPress("8", id);
            case "NINE":
                return this.handleKeyPress("9", id);
            default:
        }
    }

    public componentWillUnmount(): void {
        if(this.props && this.props.fromSearch){
            this.elementSearch && typeof this.elementSearch.removeEventListener ==='function' && this.elementSearch.removeEventListener('keydown', this.onKeyPress, true);
            return;
        }
        document.removeEventListener("keydown", this.onKeyPress, true);
    }

    public componentDidMount(): void {
        const { emptyFunctionArr } = this.props;

        if(Array.isArray(emptyFunctionArr) && emptyFunctionArr.length === 0){
            emptyFunctionArr.push(()=>{ this.handleEmptyTabClick() });
        }

        if(this.props && this.props.fromSearch){
                const parent = document.getElementsByClassName(`aaf_main_search_container`);
                if(parent && parent[0]){
                   this.elementSearch =  parent[0];
                   this.elementSearch && typeof this.elementSearch.removeEventListener ==='function' && this.elementSearch.removeEventListener('keydown', this.onKeyPress, true);
                   this.elementSearch && typeof this.elementSearch.addEventListener ==='function' && this.elementSearch.addEventListener('keydown', this.onKeyPress, true);
                }
            return;
        }
        document.removeEventListener("keydown", this.onKeyPress, true);
        document.addEventListener("keydown", this.onKeyPress, true);
    }

    private getKeySet(): Keys {
        const { activeKeyset: activeKeys } = this.state;

        switch (activeKeys) {
            case KeyName.SYMBOLS:
                return SYMBOL_KEYS;
            case KeyName.UPPER_CASE_LETTER:
                return UPPER_CASE_KEYS;
            case KeyName.LOWER_CASE_LETTERS:
                return LOWER_CASE_KEYS;
            default:
                throw new Error(`Invalid keyset name ${activeKeys}`);
        }
    }

    @autobind
    private handleEmptyTabClick(): void {
        const { $form } = this.context;
        const { emptyAllField = false, emptyCallback} = this.props;
        $form.empty(emptyAllField, emptyCallback);
    }

    @autobind
    private handleDeleteTabClick(): void {
        const { onControlDeleteCallback } = this.props;
        const { $form } = this.context;
        const { activeField = '', values = {} } = $form || {};
        const deleteFunction = () => {
            const { $form } = this.context;
            $form.sliceValue(0, -1);
        }
        if(typeof onControlDeleteCallback === 'function'){
            onControlDeleteCallback(activeField, values, deleteFunction);
        }
        else{
            deleteFunction();
        }
    }

    @autobind
    private handleAlphabetTabClick(): void {
        this.setState({
            activeTab: TabType.LETTERS,
            activeKeyset: KeyName.LOWER_CASE_LETTERS
        });
    }

    @autobind
    private handleSymbolsTabClick(): void {
        this.setState({
            activeTab: TabType.SYMBOLS,
            activeKeyset: KeyName.SYMBOLS
        });
    }

    @autobind
    private handleKeyPress(value: string | symbol, keyboardId: string | undefined): void {
        const { $form } = this.context;
        const {activeField = '', values: {mobile = ''} = {}} = $form || {};
        const {filteredFuncion = false, id} = this.props;
        if (id !== keyboardId) return;

        switch (value) {
            case SHIFT:
                this.setState(state => ({
                    activeKeyset:
                        state.activeKeyset === KeyName.UPPER_CASE_LETTER
                            ? KeyName.LOWER_CASE_LETTERS
                            : KeyName.UPPER_CASE_LETTER
                }));
                break;
            default:
                if (typeof filteredFuncion === 'function'){
                    $form.appendValue(filteredFuncion(value.toString(), activeField) as string);
                }else{
                    $form.appendValue(value as string);
                }
            }
        }

    private getContextKeysFromMetadata(){
        try{
            const contextKeysMetadataString = Metadata.get("keyboard_context_keys", CONTEXT_KEYS_STRING);
            const contextKeysMetadataObj = JSON.parse(contextKeysMetadataString);
            return contextKeysMetadataObj[this.region] || contextKeysMetadataObj["default"];
        }
        catch(err){
            return CONTEXT_KEYS.get(this.region) || CONTEXT_KEYS.get("default");
        }
    }

    @autobind
    private handleMouseEnter (e: any): void  {
        Utils.handleMouseEnter(e)
    }

    public render(): JSX.Element {
        const { activeTab } = this.state;
        const { className, onlyDigits, withoutEmails = false , id} = this.props;
        const keys = onlyDigits ? DIGITS_KEYS : this.getKeySet();
        const contextKeys = this.getContextKeysFromMetadata();
        const path = window.location.pathname;
        this.isPathSearchWithStyles = path.includes('search');
        const {modalType = ""} = store.getState().modal
        const { isFlowSearcherForPin = false} = store.getState().searcher;
        const validateModalPinAndSearcher = modalType === MODAL_PIN && this.props.sourceSearcher && isFlowSearcherForPin || this.isPathSearchWithStyles;
        const classExtraEraser = validateModalPinAndSearcher ? 'eraser' : '';
        const classExtraEmpty = validateModalPinAndSearcher ? 'empty' : '';
        const classExtraLetters = validateModalPinAndSearcher ? 'letters' : '';
        const classExtraSymbols = validateModalPinAndSearcher ? 'symbols' : '';
        const classExtraKeyTab = validateModalPinAndSearcher ? `${KEYBOARD_TABS}-searcher` : `${KEYBOARD_TABS}`;
        const classExtraHeader = validateModalPinAndSearcher ? `${KEYBOARD_HEADER}-searcher` : `${KEYBOARD_HEADER}`;

        return (
            <div className={cls(KEYBOARD, className)} onFocus={this.props.onFocus} id="Keyboard">
                <div className={classExtraHeader}>
                    {!onlyDigits &&
                        <div className={KEYBOARD_TABS}>
                            <Tab
                                id = {String(`keyB-${Math.floor(10000 + Math.random() * 90000)}`)}
                                className={`${classExtraLetters} focusable`}
                                onClick={this.handleAlphabetTabClick}
                                active={activeTab === TabType.LETTERS}
                                onMouseEnter = {this.handleMouseEnter}
                            >
                                abc
                            </Tab>
                            <Tab
                                id = {String(`keyB-${Math.floor(10000 + Math.random() * 90000)}`)}
                                className={`${classExtraSymbols} focusable`}
                                onClick={this.handleSymbolsTabClick}
                                active={activeTab === TabType.SYMBOLS}
                                onMouseEnter = {this.handleMouseEnter}
                            >
                                #123
                            </Tab>
                        </div>
                    }
                    <div className={classExtraKeyTab}>
                        <Tab onClick={this.handleDeleteTabClick} 
                            id = {'keyB-Borrar'}
                            onMouseEnter={()=>{this.handleMouseEnter('keyB-Borrar')}} 
                            transparent className={`${classExtraEraser} focusable`}>
                            <ColoredButton color="green">{Translator.get('keyboard_access_option_button_delete', 'BORRAR').toUpperCase()}</ColoredButton>
                        </Tab>
                        <Tab onClick={this.handleEmptyTabClick} 
                            id = {'keyB-Vaciar'}
                            onMouseEnter={()=>{this.handleMouseEnter('keyB-Vaciar')}} 
                            transparent className={`${classExtraEmpty} focusable`}>
                            <ColoredButton color="blue">{Translator.get('keyboard_access_option_button_empty', 'VACIAR')}</ColoredButton>
                        </Tab>
                    </div>
                </div>
                <Keyset  onMouseEnter={() => this.handleMouseEnter} keyset={keys} onKeyClick={(e) => this.handleKeyPress(e, id)} classNameItem='border-radius-50'/>
                {
                    (withoutEmails)  || !onlyDigits && activeTab === TabType.LETTERS && <Keyset  onMouseEnter={() => this.handleMouseEnter} centered calculateItemsSize={false} itemWidth='auto' classNameItem='border-radius-5' paddingHorizontalItem='8px' keyset={contextKeys} onKeyClick={(e) => this.handleKeyPress(e, id)} />
                }
                {
                    !onlyDigits &&
                        <Keyset
                            calculateItemsSize={false}
                            centered
                            keyset={FIXED_KEYS}
                            classNameItem='border-radius-50'
                            onKeyClick={(e) => this.handleKeyPress(e, id)}
                            isPay={this.isPathSearchWithStyles}
                            onMouseEnter={() => this.handleMouseEnter}
                        />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/packages/components/lib/Keyboard/index.tsx